module.exports = __webpack_public_path__ + "static/media/Games_Image@3x.72fbf5c1.png";